import { useEffect, useState } from "react";
import { getWorkspaceOverview } from "./api";

export default function useWorkspaceOverview() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      setLoading(true);
      setError("");
      const next = await getWorkspaceOverview();
      setData(next);
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to load workspace overview");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return {
    data,
    loading,
    error,
    refresh,
  };
}
